import { render, staticRenderFns } from "./SearchList.vue?vue&type=template&id=7ffa2610&scoped=true"
import script from "./SearchList.vue?vue&type=script&lang=js"
export * from "./SearchList.vue?vue&type=script&lang=js"
import style0 from "./SearchList.vue?vue&type=style&index=0&id=7ffa2610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa2610",
  null
  
)

export default component.exports